<div>
    <div class="svgicon svgicon--telescope-404 not-found__icon"></div>
    <div class="not-found__cant-find-text" bd-i18n="Global.Text.CantFindPage">Hmm...we can't find that page!</div>
    <div class="not-found__sorry-text" bd-i18n="Global.Text.SorryAboutThat">Sorry about that. Want to look for something else?</div>
</div>
